import axios from 'axios';

// Config
import constants from '../config/constants';

// eslint-disable-next-line import/prefer-default-export
export const sendEmailMessage = (data) => axios.post(constants.sendEmailUrl, data);
export const sendEmailError = (data) => axios.post(constants.sendEmailErrorUrl, data);
